import NextLink from 'next/link';
import { useState } from 'react';
import {
  Box,
  Flex,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from '@eqi-investimentos/react';
import { useT } from '@/libs/i18n/utils/useT';
import { useGetListBrokers } from '@/modules/Wallet/http/client/useGetListBrokers';
import { Icon } from '@/components/elements/Icon';
import { Thumb } from '@/components/elements/Thumb';
import { IfRender, MapRender } from '@/utils/jsx';
import { LoadingBrokerSection } from './Skeleton';

export const BrokersSection = () => {
  const t = useT();

  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const { data: listBrokers = [], status } = useGetListBrokers();

  const tabsOption = Array.from({ length: 4 }).map((_, index) => ({
    name: t(`screens.invest.redirectBroker.tabs.option${index}.title`),
    type: t(`screens.invest.redirectBroker.tabs.option${index}.type`),
  }));

  const brokersTabSelected = listBrokers.filter(
    ({ type }) => type === tabsOption[activeTabIndex]?.type
  );

  return (
    <Box overflowX="hidden">
      <IfRender condition={status === 'pending'}>
        <LoadingBrokerSection />
      </IfRender>
      <IfRender condition={status !== 'pending'}>
        <Flex
          flexDir="column"
          sx={{
            '&::-webkit-scrollbar': { display: 'none' },
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
          }}
        >
          <Text size="2xl" fontWeight="semibold" color="content.primary">
            {t('screens.invest.redirectBroker.title')}
          </Text>

          <Box py="l" pb="5xl" w="full">
            <Tabs>
              <TabList
                overflowX="scroll"
                sx={{
                  '&::-webkit-scrollbar': { display: 'none' },
                  scrollbarWidth: '0.4px',
                }}
              >
                <MapRender
                  items={tabsOption}
                  render={({ name }, index) => (
                    <Tab key={index} onClick={() => setActiveTabIndex(index)}>
                      {name}
                    </Tab>
                  )}
                />
              </TabList>
              <TabPanels>
                <MapRender
                  items={brokersTabSelected}
                  render={({ id, name, url_campaign, thumb_img }) => (
                    <TabPanel>
                      <Flex
                        as={NextLink}
                        href={url_campaign}
                        target="_blank"
                        rel="noopener noreferrer"
                        key={id}
                        flexDir="row"
                        gap="s"
                        borderBottom="1px solid"
                        borderColor="border.secondary"
                        py="s"
                        align="center"
                        justify="space-between"
                        px="s"
                        _hover={{
                          bg: 'background.brandLight',
                        }}
                      >
                        <Flex gap="xs" flexDir="row" align="center">
                          <Thumb
                            src={thumb_img || ''}
                            width={40}
                            height={40}
                            fit="cover"
                            alt={name}
                          />
                          <Text size="l" color="content.primary">
                            {name}
                          </Text>
                        </Flex>
                        <Icon
                          iconName="ChevronRight"
                          w={24}
                          h={24}
                          color="content.brand"
                        />
                      </Flex>
                    </TabPanel>
                  )}
                />
              </TabPanels>
            </Tabs>
          </Box>
        </Flex>
      </IfRender>
    </Box>
  );
};
